<template>
  <div class="flex flex-col gap-4">
    <h2 class="text-sm font-bold text-blue">
      In order to provide you with the most relevant information, please answer
      the following:
    </h2>

    <HorizontalSeparator />

    <div
      class="flex cursor-pointer items-center gap-4 text-blue-30"
      @click="$emit('selectType', 'cnd')"
    >
      <img
        class="h-24"
        :src="asset_path('/images/interstitial-employer-desktop.png')"
        alt="Image of a candidate"
      />
      <p>
        I am looking for a
        <span class="font-bold text-orange underline">job</span>
        <br />
        (a candidate)
      </p>
    </div>

    <div
      class="flex cursor-pointer items-center gap-4 text-blue-30"
      @click="$emit('selectType', 'emp')"
    >
      <img
        class="h-24"
        :src="asset_path('/images/interstitial-jobseeker-desktop.png')"
        alt="Image of an employer"
      />
      <p>
        I am an
        <span class="font-bold text-orange underline">employer</span>
      </p>
    </div>
  </div>
</template>

<script>
import HorizontalSeparator from 'Components/HorizontalSeparator';

export default {
  name: 'ContactUserTypeForm',
  components: { HorizontalSeparator },
};
</script>
